import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { SmartTextEditor } from '@bingads-webui-campaign-react/smart-component-text';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { isValidUrl } from '@bingads-webui-campaign-react/smart-component-util';

const getStyles = () => ({
  toggle: {
    position: 'absolute',
    right: 40,
    marginTop: 5,
    zIndex: 1,
  },
  root: {
    margin: '15px 0',
  },
});

export const SmartSocialLinkEditor = ({
  i18n,
  componentId,
  socialLinkKey,
  socialLinkLabel,
  linkPlaceholder,
  onValueChange,
  onToggleChange,
  enabled,
  value,
}) => {
  const classes = useDefaultStyles(getStyles);
  const toggleText = i18n.getString(_TL_('Display on website'));
  const toggleLabel = `${socialLinkLabel} ${toggleText}`;

  const validateLink = useCallback((val) => {
    if (isValidUrl(val)) {
      return '';
    }
    return i18n.getString(_TL_('Invalid link'));
  }, [i18n]);

  return (
    <div id={componentId} className={classes.root}>
      <Toggle
        className={classes.toggle}
        ariaLabel={toggleLabel}
        inlineLabel
        onText={toggleText}
        offText={toggleText}
        checked={enabled}
        onChange={onToggleChange}
      />
      <div data-editable-property={socialLinkKey} >
        <SmartTextEditor
          label={socialLinkLabel}
          onChange={onValueChange}
          value={value}
          placeholder={linkPlaceholder}
          validation={validateLink}
        />
      </div>
    </div>
  );
};

SmartSocialLinkEditor.defaultProps = {
  value: '',
};

SmartSocialLinkEditor.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  componentId: PropTypes.string.isRequired,
  socialLinkKey: PropTypes.string.isRequired,
  socialLinkLabel: PropTypes.string.isRequired,
  linkPlaceholder: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onToggleChange: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  value: PropTypes.string,
};
